import React, { FunctionComponent, SVGProps } from 'react'

export const IconClear: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    stroke="#9595a3"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 5.5L5 15.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5 5.5L15 15.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
)
